"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PosaMessageConsumer = exports.PosaMessageProvider = void 0;
const react_1 = __importDefault(require("react"));
const PosaMessageContext = react_1.default.createContext({});
exports.PosaMessageProvider = PosaMessageContext.Provider;
exports.PosaMessageConsumer = PosaMessageContext.Consumer;
exports.default = PosaMessageContext;
//# sourceMappingURL=PosaMessageContext.js.map